


















































































































































































































































































































































































































import {
  defineComponent,
  toRefs,
  getCurrentInstance,
  ComponentInternalInstance,
  ref,
  watch,
  computed,
  onUnmounted,
  onMounted,
} from '@vue/composition-api';
import { StarIcon, StarFilledIcon, EllipsisIcon, DownloadIcon, ShareIcon, FolderIcon } from 'tdesign-icons-vue';

// 引入 vue 组件
import renameFolderDialog from '@/renderer/components/dialog/rename.vue';
import linkShare from '@/renderer/components/dialog/linkShare/index.vue';
import WemeetLinkShare from '@/renderer/components/dialog/linkShare/WemeetShare.vue';
import AddFileAuth from '@/renderer/components/dialog/AddTransfer/AddFileAuth/index.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import FileApplyDialog from '@/renderer/components/dialog/FileApply/components/FileApplyDialog.vue';
import FileIcon from '@/renderer/components/Base/BaseTableFileIcon/FileIcon.vue';

// 引入 compositions
import extraFileInfoHandler from '@/renderer/components/SpacePage/compositions/extraFileInfoHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import renameHandler from '@/renderer/components/SpacePage/compositions/renameHandler';
import linkShareHandler from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import deleteHandler from '@/renderer/components/SpacePage/compositions/deleteHandler';
import authHandler from '@/renderer/components/SpacePage/compositions/authHandler';
import shareInWeMeetingHandler from '@/renderer/views/desktop/headbar/composition/shareInWeMeetingHandler';
import recentUseListHandler from '@/renderer/views/desktop/FileManagement/Workbench/RecentUse/recentUseListHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import drawerHandler from '@/renderer/views/desktop/FileManagement/Workbench/composition/drawerHandler';
import { actionHandler } from '@/renderer/components/SpacePage/compositions/actionHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

// 引入工具类
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import { can, optAuth } from '@/renderer/scripts/composition/authHandler';
import storage from '@/renderer/scripts/utils/storage';
import ipc from '@/renderer/scripts/utils/ipc';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import tips from '@/renderer/scripts/utils/tips';
import { GetDropdownItemShortCutText } from '@/renderer/scripts/utils/hotkeyDataHelper';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import {
  noPreview,
  isAllowPreviewImage,
  isAllowPrivate,
  isAllowEditDoc,
} from '@/renderer/scripts/composition/allowPreview';
import { openFolderOrDirectory } from '@/renderer/scripts/utils/openFolderOrDirectory';
import i18n, { i18n_t } from '@/locales/i18n';

export default defineComponent({
  name: 'RecentUse',
  components: {
    FileIcon,
    FileApplyDialog,
    StatusTag,
    StarIcon,
    StarFilledIcon,
    EllipsisIcon,
    DownloadIcon,
    ShareIcon,
    renameFolderDialog,
    linkShare,
    WemeetLinkShare,
    AddFileAuth,
    Menu,
    MenuItem,
    FolderIcon,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const router = vm.$router;
    const spaceId = ref('');
    const spaceOrgId = ref(-1);
    const {
      columns,
      pageData,
      tableData,
      loading: loadingList,
      loadingOnHeader,
      methods: listMethods,
    } = recentUseListHandler();
    const noDisableRoleSelect = computed(() => tableData.selectedList[0]?.spaceTag === 'personal');
    const requestPermissionVisible = ref(false);
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      isDropdownShow,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const resizeColumns = computed<any[]>(() => {
      const checkboxColumn = {
        colKey: 'row-select',
        type: 'multiple',
        width: 20,
      };
      if (props.showCheckbox) {
        return [checkboxColumn, ...columns.value];
      }
      return setResizableColumns(columns.value);
    });
    const departmentList = computed(() => tableData.selectedList[0]?.path || []);
    const currentUser = computed(() => store.getters.userBaseInfo);
    const { methods: previewMethods } = openPreviewHandler(spaceId, spaceOrgId);
    const { methods: extraFileInfoMethods } = extraFileInfoHandler(spaceId);
    const { methods: downloadMethods } = downloadHandler(spaceId);
    const { methods: deleteMethods } = deleteHandler(spaceId);
    const {
      show: showRename,
      originName: fromName,
      type: renameType,
      methods: renameMethods,
      renameError,
    } = renameHandler(spaceId);
    const { show: showLink, showWemeetShare, linkData, methods: linkShareMethods } = linkShareHandler(spaceId);
    const { show: showAuth, authParams, teamId: authTeamId, methods: authMethods } = authHandler(spaceId);
    const { filterMethods, comboMethods } = actionHandler();
    const { methods: wemeetingMethods } = shareInWeMeetingHandler();
    const { name } = router.currentRoute;
    const canCopyMove = ref(name !== 'relatedToMeFileList');
    // 已失效item不展示右键菜单
    const showMenu = computed<boolean>(() => tableData.selectedList[0] && !tableData.selectedList[0]?.visible);
    const focusList = () => {
      const { filePageRef }: any = (currComponent as ComponentInternalInstance).refs;
      filePageRef.focus({
        preventScroll: true,
      });
    };

    const methods = {
      onOperateEventProxy(command: string, item: any, btnLocation?: string) {
        if (item) {
          spaceId.value = item.spaceId;
          spaceOrgId.value = item.spaceOrgId;
        }
        switch (command) {
          case 'open':
          case 'preview':
            if (!item.visible) {
              tips.error(i18n_t('已被删除，请前往误删恢复找回'));
            } else if (noPreview(item)) {
              tips.error(i18n_t('该格式暂不支持在线预览'));
            } else if (!can('Preview', item)) {
              tips.error(i18n_t('暂无在线预览权限，请联系管理员'));
            } else if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              const team =
                item.spaceTag === 'team'
                  ? {
                      teamId: item?.team?.id,
                    }
                  : {};
              previewMethods.openPreview(item, 1, {
                ...team,
              });
            }
            break;
          case 'auth':
            {
              if (checkIfMobileStyle()) return;
              const params = {
                userId: item.userId,
                virusAuditStatus: item.virusAuditStatus,
                path: item.path.join('/'),
                spaceTag: item.spaceTag,
                teamId: item.team?.id,
              };
              const canOpenAuthDialog = authMethods.canOpenAuthDir(params);
              if (!canOpenAuthDialog) return;
              Object.assign(authParams, { params });
              showAuth.value = true;
            }
            break;
          case 'delete':
            if (!item.visible) {
              tips.error(i18n_t('已被删除，请前往误删恢复彻底删除'));
            } else {
              const deleteData = item ? [item] : tableData.selectedList;
              deleteMethods.confirmDelete(deleteData, false, focusList);
              reporter.report('delete', {
                delete_location: router.currentRoute.name,
              });
            }
            break;
          case 'download':
            {
              const downloadData = item ? [item] : tableData.selectedList;
              downloadMethods.prepareDownload(downloadData);
              reporter.report('download', {
                download_location: 'recentUse',
                download_mode: 'single_download',
                batch_num: 1,
                downloadData,
                file_name: item?.name || '',
              });
            }
            break;
          case 'rename':
            renameMethods.openRenameFolder(item);
            break;
          case 'edit':
            if (!item.authorityList?.canModify) {
              tips.error(i18n_t('暂无权限，请联系管理员'));
            } else {
              previewMethods.openEdit(item);
            }
            break;
          case 'share':
            {
              const shareData = item ? [item] : tableData.selectedList;
              if (store.getters.isInWeMeetApp) {
                const { preview, edit } = methods.getFileOrDirPermission(shareData[0]);
                shareData[0] = {
                  ...item,
                  canPreview: preview,
                  canEdit: edit,
                };
              }
              linkShareMethods.openShare(shareData);
            }
            break;
          case 'addFavorite':
            {
              const favoriteData: any = item || tableData.selectedList[0];
              extraFileInfoMethods.addFavorite(favoriteData, tableData.list);
            }
            break;
          case 'delFavorite':
            {
              const favoriteData: any = item || tableData.selectedList[0];
              const favorIds = [favoriteData.favoriteId];
              extraFileInfoMethods.delFavorite(favorIds, tableData.list, spaceOrgId.value);
            }
            break;
          case 'detail':
          case 'history':
            tableData.selectedRowKeys = [item.id];
            tableData.selectedList = [item];
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_SHOW_DETAIL, command);
            break;
          case 'invite_to_preview':
          case 'invite_to_edit': {
            const selectedItem = item || tableData.selectedList[0];
            const [, , action] = command.split('_');
            wemeetingMethods.share(action, {
              ...selectedItem,
              spaceId: spaceId.value,
              btnLocation,
            });
            break;
          }
          case 'openOriginDirectroy':
            {
              openFolderOrDirectory({ item, isOpenFolder: false });
            }
            break;
          case 'esign': {
            previewMethods.openPreview(item, 1, {
              esign: true,
            });
            break;
          }
          case 'requestPermission':
            requestPermissionVisible.value = true;
            break;
          default:
            break;
        }
      },
      renderRowClass(params: any) {
        const className = [];
        // 是否选中
        const isSelected = tableData.selectedRowKeys.join(',').includes(params?.row.id.toString()) ? 'is-selected' : '';
        // 是否被禁用
        const isDisable = params.row?.visible === false ? 'disable' : '';
        isSelected && className.push(isSelected);
        isDisable && className.push(isDisable);
        return className.join(' ');
      },
      getFileOrDirPermission(item: any): Record<string, boolean> {
        let actionMap = comboMethods.getFileOrDirPermission([item], true);
        actionMap = filterMethods.filterAll(actionMap, item);
        return actionMap;
      },
      renderDropdownItemOptions(item: SMH.RecentlyUsedFileItemData) {
        const map: Record<string, string> = {
          // 腾讯会议中此2入口放最上
          invite_to_preview: i18n_t('邀请预览'),
          invite_to_edit: i18n_t('邀请编辑'),
          detail: i18n_t('详情'),
          download: i18n_t('下载'),
          preview: i18n_t('在线预览'),
          edit: i18n_t('在线编辑'),
          esign: i18n_t('发起电子签'),
          requestPermission: i18n_t('权限申请'),
          rename: i18n_t('重命名'),
          addFavorite: i18n_t('收藏'),
          delFavorite: i18n_t('取消收藏'),
          auth: i18n_t('添加共享成员'),
          history: i18n_t('历史版本'),
          delete: i18n_t('删除'),
        };
        const allow: Record<string, boolean> = methods.getFileOrDirPermission(item);
        const options: Array<{
          content: string;
          value: string;
        }> = [];
        Object.keys(map).forEach(key => {
          if (allow[key]) {
            options.push({
              content: map[key],
              value: key,
            });
          }
        });
        return options;
      },
      silentRefresh() {
        listMethods.silentRefresh();
      },
    };
    watch(
      () => [showWemeetShare.value, showAuth.value, showRename.value, showLink.value],
      () => {
        if (!showWemeetShare.value && !showAuth.value && !showRename.value && !showLink.value) {
          focusList();
        }
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, listMethods.refresh);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, listMethods.refresh);
    });
    if (vm.$route.name === 'recentUse') {
      // 最近使用单独路由页需要自行初始化抽屉
      drawerHandler();
    }
    const handleHotKeyAction = (action: string): boolean => {
      // 过滤t-dialog弹窗打开的情况
      if (
        loadingList.value ||
        tableData.selectedRowKeys.length <= 0 ||
        !tableData.selectedList[0].visible ||
        [...document.getElementsByClassName('t-dialog__ctx')].filter(e => (e as HTMLElement).style.display !== 'none')
          .length > 0
      ) {
        return false;
      }
      const allow: Record<string, boolean> = methods.getFileOrDirPermission(tableData.selectedList[0]);
      switch (action) {
        case 'rename':
          if (allow.rename) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'open':
          methods.onOperateEventProxy(action, tableData.selectedList[0]);
          return true;
        case 'download':
          if (optAuth('Download', tableData.selectedList[0] as any)) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'share':
          if (allow.share) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          return true;
        case 'delete':
          if (allow.delete) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'addFavorite':
        case 'delFavorite':
          if (tableData.selectedRowKeys.length === 1) {
            if (allow.addFavorite) {
              methods.onOperateEventProxy('addFavorite', tableData.selectedList[0]);
              return true;
            }
            if (allow.delFavorite) {
              methods.onOperateEventProxy('delFavorite', tableData.selectedList[0]);
              return true;
            }
          }
          break;
        default:
          break;
      }
      return false;
    };
    return {
      departmentList,
      spaceId,
      requestPermissionVisible,
      currentUser,
      resizeColumns,
      pageData,
      listMethods,
      loadingList,
      loadingOnHeader,
      canCopyMove,
      showRename,
      fromName,
      renameType,
      renameMethods,
      renameError,
      showLink,
      showWemeetShare,
      linkData,
      showAuth,
      authTeamId,
      authParams,
      authMethods,
      can,
      optAuth,
      showMenu,
      noDisableRoleSelect,
      operateShowMap,
      isDropdownShow,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      listOperateMethods,
      handleHotKeyAction,
      GetDropdownItemShortCutText,
      ...toRefs(tableData),
      ...methods,
    };
  },
});
